'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';
import CVModal from '../components/CVModal';

interface CVModalContextType {
  isCVModalOpen: boolean;
  openCVModal: () => void;
  closeCVModal: () => void;
  downloadCV: () => void;
}

const CVModalContext = createContext<CVModalContextType | undefined>(undefined);

export function CVModalProvider({ children }: { children: ReactNode }) {
  const [isCVModalOpen, setIsCVModalOpen] = useState(false);

  const openCVModal = () => setIsCVModalOpen(true);
  const closeCVModal = () => setIsCVModalOpen(false);

  const downloadCV = () => {
    const link = document.createElement('a');
    link.href = '/assets/documents/Marwan-Hussein-CV.pdf';
    link.download = 'Marwan-Hussein-CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <CVModalContext.Provider
      value={{
        isCVModalOpen,
        openCVModal,
        closeCVModal,
        downloadCV,
      }}
    >
      {children}
      <CVModal isOpen={isCVModalOpen} onClose={closeCVModal} onDownload={downloadCV} />
    </CVModalContext.Provider>
  );
}

export function useCVModal() {
  const context = useContext(CVModalContext);
  if (!context) {
    throw new Error('useCVModal must be used within a CVModalProvider');
  }
  return context;
}
